var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectionsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.502,
    height: 20,
    viewBox: "0 0 19.502 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doctor_male",
    transform: "translate(-6 -5.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M25.011,9.81c0,1.875-.466,4.32-1.182,3.949a4.335,4.335,0,0,1-8.457-.834c-.711-1.245-1.644-3.738.754-5.682.043-.014.069-.131.109-.3a2.031,2.031,0,0,1,2.551-1.824C20.385,5.33,25.011,6.155,25.011,9.81ZM22.95,10.992a2.78,2.78,0,0,0-.015,1.514,3.25,3.25,0,0,1-6.5.107,6.506,6.506,0,0,0,.078-1.363c0-1.011,0-2.2.462-2.691A14.544,14.544,0,0,0,22.95,10.992Z",
    transform: "translate(-3.933)",
    fill: "#9180eb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M9.792,32.334a1.624,1.624,0,0,1,.776-1.386c-.017-.065-.034-.133-.05-.2-.075-.326-.142-.722-.192-1.12a10.635,10.635,0,0,1-.084-1.087C7.956,29.436,6,31,6,32.643v2.942H25.5V32.643c0-1.573-1.793-3.074-3.954-3.987v.015a8.936,8.936,0,0,1-.045,1.075c-.033.338-.081.675-.139.964h.344a.542.542,0,0,1,.485.3l.542,1.083a.541.541,0,0,1,.057.242v1.083a.542.542,0,0,1-.542.542H21.169V32.876h.542v-.414l-.335-.67h-1.5l-.335.67v.414h.542v1.083H19a.542.542,0,0,1-.542-.542V32.334a.541.541,0,0,1,.057-.242l.542-1.083a.542.542,0,0,1,.485-.3h.712q.018-.07.036-.155a8.572,8.572,0,0,0,.135-.913,7.877,7.877,0,0,0,.04-.94,2.806,2.806,0,0,0-.027-.338.713.713,0,0,0-.026-.12h0s0,0,0,0h0c-.29-.09-.581-.168-.872-.235-.272-.062-.554.313-.678.548H12.5l-.047-.091c-.115-.229-.256-.511-.5-.456q-.313.071-.626.161c-.006.08-.009.176-.008.286A9.223,9.223,0,0,0,11.4,29.49c.046.369.108.729.173,1.013.019.082.037.156.055.219a1.625,1.625,0,1,1-1.838,1.611Z",
    transform: "translate(0 -10.503)",
    fill: "#9180eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M16.083,35.535a.542.542,0,1,1-.542-.55A.546.546,0,0,1,16.083,35.535Z",
    transform: "translate(-4.124 -13.704)",
    fill: "#9180eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionsIcon);
export default __webpack_public_path__ + "static/media/connections-icon.8f1a1a7468fb34e51bc42ab32632fea0.svg";
export { ForwardRef as ReactComponent };